

import React from 'react';
import { connect } from 'react-redux';
import loadingMainLogo from '../../ImageAssets/Apua_New_Logo.png';

class PortalLoadingScreenComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        }
    }

    render() {
        const PortalLoadingScreenMainContainerStyle = { height: this.state.windowHeight + 'px', backgroundColor: '#FFFFFF' };
        return (
            <div className="loadingScreenMainContainer d-flex align-items-center justify-content-center animated fadeIn" style={PortalLoadingScreenMainContainerStyle}>
                <div>
                    <div style={{ textAlign: "center" }}><img alt="" src={loadingMainLogo} /> </div>
                    <div style={{ textAlign: "center", fontWeight: 'bold', paddingTop: 10, fontStyle: 'italic' }}>{this.props.locales.welcomeToSelfcareLoadingText}</div>
                    {/* values from locales =>> <div style={{textAlign:"center"}}>{this.props.locales.keyName}</div> */}
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}

function mapDispatchToProps(dispatch) {
    return {}
}

const PortalLoadingScreenComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PortalLoadingScreenComponent)


export default PortalLoadingScreenComponentContainer;


